import React from 'react';
import { Trash2 } from 'lucide-react';
import { t } from '../../i18n/languages';

function DeleteUserModal({
  isOpen,
  user,
  currentLanguage,
  employmentEndDate,
  setEmploymentEndDate,
  onClose,
  onConfirm
}) {
  if (!isOpen || !user) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '24px',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            backgroundColor: '#fef2f2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <Trash2 size={24} color="#ef4444" />
          </div>
          <div>
            <h3 style={{
              margin: 0,
              fontSize: '18px',
              fontWeight: '600',
              color: '#1f2937'
            }}>
              {t('deleteUser', {}, currentLanguage)}
            </h3>
          </div>
        </div>

        <p style={{
          margin: '0 0 16px 0',
          fontSize: '14px',
          color: '#6b7280',
          lineHeight: '1.5'
        }}>
          {t('setEmploymentEndDate', { userName: user.name }, currentLanguage)}
        </p>

        <div style={{ marginBottom: '24px' }}>
          <label style={{
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            color: '#374151',
            marginBottom: '6px'
          }}>
            {t('employmentEndDate', {}, currentLanguage)}
          </label>
          <input
            type="date"
            value={employmentEndDate}
            onChange={(e) => setEmploymentEndDate(e.target.value)}
            required
            style={{
              width: '100%',
              padding: '12px',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px'
            }}
          />
        </div>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 20px',
              backgroundColor: 'transparent',
              color: '#6b7280',
              border: '1px solid #d1d5db',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = '#f3f4f6';
              e.target.style.color = '#374151';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6b7280';
            }}
          >
            {t('cancel', {}, currentLanguage)}
          </button>
          <button
            onClick={onConfirm}
            disabled={!employmentEndDate}
            style={{
              padding: '10px 20px',
              backgroundColor: employmentEndDate ? '#ef4444' : '#9ca3af',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              cursor: employmentEndDate ? 'pointer' : 'not-allowed',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={(e) => {
              if (employmentEndDate) {
                e.target.style.backgroundColor = '#dc2626';
              }
            }}
            onMouseOut={(e) => {
              if (employmentEndDate) {
                e.target.style.backgroundColor = '#ef4444';
              }
            }}
          >
            {t('setDateAndDelete', {}, currentLanguage)}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteUserModal;
